import * as K from 'common/constants';
import Link from 'components/common/Link/Link';

/**
 * This component represents the special UX for displaying the log results of a search with no matching events.
 */
function NoLogResults(): JSX.Element {

  return (
    <div>
      <div className="LogResults__NoResults">
        <div className="LogResults__NoResultsMessage">No matching events found.</div>
        <div className="LogResults__NoResultsHint">
          &#8627; You can use your browser’s Back button to see the previous results, or&nbsp;
          <Link href={K.ROUTE.EVENTS} className="LogResults__NoResultsLink">click here</Link>
          &nbsp;to start a new search.
        </div>
      </div>
    </div>
  );
}

export default NoLogResults;
